import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PLAN_EVENT } from "@/lib/usePlanStatus";
import { formatDeShort } from "@/lib/date";

export default function PaymentResultPage({ cancelled = false }) {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "pending");
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    if (cancelled || !sid) return undefined;
    let n = 0;
    const t = setInterval(async () => {
      n += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          clearInterval(t);
          setState("paid");
          window.dispatchEvent(new Event(PLAN_EVENT));
          api.get("/plan/status").then((r) => setPlan(r.data)).catch(() => {});
        }
        else if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); clearInterval(t); }
      } catch { /* weiter versuchen */ }
      if (n > 20) { setState((s) => (s === "pending" ? "timeout" : s)); clearInterval(t); }
    }, 2000);
    return () => clearInterval(t);
  }, [sid, cancelled]);
  const view = {
    pending: [Loader2, "Zahlung wird bestätigt…", "Einen Moment bitte.", "text-slate-500 animate-spin"],
    paid: [CheckCircle2, "Zahlung erfolgreich", "Dein Monats-Abo ist aktiv und verlängert sich automatisch.", "text-emerald-600"],
    failed: [XCircle, "Zahlung fehlgeschlagen", "Bitte versuche es erneut.", "text-red-600"],
    cancelled: [XCircle, "Zahlung abgebrochen", "Es wurde nichts berechnet.", "text-slate-400"],
    timeout: [Loader2, "Bestätigung dauert länger", "Bitte lade die Seite gleich neu.", "text-amber-500"],
  }[state];
  const [Icon, title, text, cls] = view;
  return (
    <div className="max-w-md mx-auto p-10 text-center" data-testid={`payment-${state}`}>
      <Icon size={44} className={`mx-auto ${cls}`} />
      <h1 className="font-heading text-2xl mt-4">{title}</h1>
      <p className="text-sm text-slate-500 mt-1">{text}</p>
      {state === "paid" && plan && <p className="text-sm mt-2" data-testid="payment-plan">Tarif <b>{plan.plan.name}</b> · nächste Verlängerung <b>{formatDeShort(plan.paid_until.slice(0, 10))}</b></p>}
      <Link to="/traeger?tab=tarif" className="inline-block mt-6 px-5 py-2.5 bg-slate-900 text-white text-sm" data-testid="payment-back">Zum Tarif</Link>
    </div>
  );
}
